import { createContext } from 'react';
import type React from 'react';
/** Bảng 8 bước đưa dòng meta + nút chính vào CHÍNH hàng trên cùng (WorkflowTopBar) — các màn khác (tải/lỗi/chi tiết video) không cấp context ⇒ thanh trên giữ nguyên. */
export const WorkflowTopExtraContext = createContext<{ meta?: React.ReactNode; primary?: React.ReactNode } | null>(null);
